import React from 'react'

import {message, Tag} from 'antd'
import GalleryTablePanel from "../../component/GalleryTablePanel";
import {connect} from "react-redux";
import {onPaginationSave} from "../../action/style";
import {SortAscendingOutlined, SortDescendingOutlined} from "@ant-design/icons";
import {withRouter} from 'react-router'
import {getEditUrl, stringToColor} from "../../component/Utils";
import {
    bulkAddArtistContact,
    bulkPatchArtistContact,
    deleteArtistContact,
    getAllArtistContact
} from '../../api/artistPartnerProfile'
import {URL_EDIT_CONTACT, URL_NEW_CONTACT} from '../../const'
import GalleryView from "../../component/base/GalleryView";
import GalleryContactCard from "../../component/contact/GalleryContactCard";
import {TYPE_CITY, TYPE_STATE, TYPE_TAG} from "../../component/base/filters/FilterUtils";
import {bulkPatchArtwork} from "../../api/artworks";

@connect(
    (state) => ({
        id: state.user.info.id, // real user id, admin_id or artist_id
        userId: state.user.info.userId, // artist user obj id
        artistId: state.user.info.artistId, // artist obj id
        artistName: state.user.info.artistName,
        email: state.user.info.email,
        role: state.user.info.role
    }),
    {
        onPaginationSave
    }
)
class Contact extends React.Component {
    constructor(props) {
        super(props)

        this.prefix = ''
        this.query = new URLSearchParams(this.props.location.search)

        this.state = {
            allContact: [],
            search: this.loadCache('search' + this.props.artistId),
            tagsFilter: "",
        }

        const formatPhoneNumber = (value) => {
          let formattedNumber = value;
          let length = value.length;
          // Filter non numbers
          const regex = () => value.replace(/[^0-9\.]+/g, "");
          // Set area code with parenthesis around it
          const areaCode = () => `(${regex().slice(0, 3)})`;

          // Set formatting for first six digits
          const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;

          // Dynamic trail as user types
          const trailer = (start) => `${regex().slice(start,   
          regex().length)}`;
            if (length < 3) {
               // First 3 digits
               formattedNumber = regex();
            } else if (length === 4) {
               // After area code
               formattedNumber = `${areaCode()} ${trailer(3)}`;
            } else if (length === 5) {
               // When deleting digits inside parenthesis
               formattedNumber = `${areaCode().replace(")", "")}`;
            } else if (length > 5 && length < 9) {
               // Before dash
               formattedNumber = `${areaCode()} ${trailer(3)}`;
            } else if (length >= 10) {
               // After dash
               formattedNumber = `${firstSix()}-${trailer(6)}`;
            }
            return formattedNumber
        };

        this.columns = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id',
                width: '60px',
                hidden: true
            },
            {
                title: 'First Name',
                dataIndex: 'first_name',
                key: 'first_name',
            },
            {
                title: 'Last Name',
                dataIndex: 'last_name',
                key: 'last_name',
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                width: "16%"
            },
            {
                title: 'Phone',
                dataIndex: 'phone_number',
                key: 'phone_number',
                width: "16%",
                render: (text, record) => {
                    if (!text) {
                        return
                    }
                    return formatPhoneNumber(text)
                }
            },
            {
                title: 'City',
                dataIndex: 'city',
                key: 'city'
            },
            {
                title: 'State',
                dataIndex: 'state',
                key: 'state'
            },
            {
                title: 'Country',
                dataIndex: 'country',
                key: 'country'
            },
            {
                title: 'Tag',
                dataIndex: 'tags',
                key: 'tags',
                render: (text, record) => {
                    if (!text) {
                        return
                    }
                    let arr = [];
                    let str1 = text

                    if (str1.length > 4) {

                        str1 = str1.substring(2, str1.length - 2)
                        let textArr = str1.split("','")

                        for (let i = 0; i < textArr.length; i++) {  
                            if (i === 3) {
                                arr.push(<Tag color="blue">{"+" + (textArr.length - 3) + "..."}</Tag>)
                                i = textArr.length
                            }
                            else {
                                var color = stringToColor(textArr[i])
                                arr.push(<Tag color={color}>{textArr[i]}</Tag >)
                            }
                        }
                        return arr;
                    }
                }
            }
        ]

        this.allColumns = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id',
                width: '60px',
                hidden: true
            },
            {
                title: 'First Name',
                dataIndex: 'first_name',
                key: 'first_name',
            },
            {
                title: 'Middle Name',
                dataIndex: 'middle_name',
                key: 'middle_name',
            },
            {
                title: 'Last Name',
                dataIndex: 'last_name',
                key: 'last_name',
            },
            {
                title: 'Job Title',
                dataIndex: 'job_title',
                key: 'job_title'
            },
            {
                title: 'Company',
                dataIndex: 'company',
                key: 'company'
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                width: "16%"
            },
            {
                title: 'Secondary Email',
                dataIndex: 'secondary_email',
                key: 'secondary_email'
            },
            {
                title: 'Phone',
                dataIndex: 'phone_number',
                key: 'phone_number'
            },
            {
                title: 'Website',
                dataIndex: 'website',
                key: 'website'
            },
            {
                title: 'Address Line 1',
                dataIndex: 'address_line1',
                key: 'address_line1'
            },
            {
                title: 'Address Line 2',
                dataIndex: 'address_line2',
                key: 'address_line2'
            },
            {
                title: 'City',
                dataIndex: 'city',
                key: 'city'
            },
            {
                title: 'State',
                dataIndex: 'state',
                key: 'state'
            },
            {
                title: 'Zipcode',
                dataIndex: 'zipcode',
                key: 'zipcode'
            },
            {
                title: 'Country',
                dataIndex: 'country',
                key: 'country'
            },
            {
                title: 'Sources',
                dataIndex: 'source',
                key: 'source',
                render: (text, record) => {
                    if (!text) {
                        return
                    }
                    let srcstr = "";
                    let str1 = text

                    if (str1.length > 4) {

                        str1 = str1.substring(2, str1.length - 2)
                        let textArr = str1.split("','")

                        for (let i = 0; i < textArr.length-1; i++) {
                            srcstr += textArr[i] + ", "
                        }
                        srcstr += textArr[textArr.length-1]
                        return (<>{srcstr}</>);
                    }
                }
            },
            {
                title: 'Tag',
                dataIndex: 'tags',
                key: 'tags',
                render: (text, record) => {
                    if (!text) {
                        return
                    }
                    let arr = [];
                    let str1 = text

                    if (str1.length > 4) {

                        str1 = str1.substring(2, str1.length - 2)
                        let textArr = str1.split("','")

                        for (let i = 0; i < textArr.length; i++) {
                            if (i === 3) {
                                arr.push(<Tag color="blue">{"+" + (textArr.length - 3) + "..."}</Tag>)
                                i = textArr.length
                            }
                            else {
                                var color = stringToColor(textArr[i])
                                arr.push(<Tag color={color}>{textArr[i]}</Tag >)
                            }
                        }
                        return arr;
                    }
                }
            },
            {
                title: 'Notes',
                dataIndex: 'notes',
                key: 'notes'
            },
        ]

        this.sortOptions = [
            {
                text: 'Last Name (a-z)',
                value: 'last_name',
                icon: <SortAscendingOutlined />
            },
            {
                text: 'Last Name (z-a)',
                value: '-last_name',
                icon: <SortDescendingOutlined />
            },
            {
                text: 'First Name (a-z)',
                value: 'first_name',
                icon: <SortAscendingOutlined />
            },
            {
                text: 'First Name (z-a)',
                value: '-first_name',
                icon: <SortDescendingOutlined />
            }
        ]
        this.filterOptions = [
            {
                type: TYPE_STATE
            },
            {
                type: TYPE_CITY,
            },
            {
                type: TYPE_TAG,
            },
        ]
    }

    loadCache(key) {
        return localStorage.getItem(this.prefix + '_' + key)
    }

    getEditUrl = (element) => {
        if (!element.id) {
            return
        }

        return getEditUrl(URL_EDIT_CONTACT, element.id)
    }

    requestData = (pageId, pageSize, sort, filters, search, cancelToken) => {
        // prepare your data from Apis or local tests
        if (filters.tagsFilter || filters.cityFilter || filters.stateFilter)
            pageId = 1

        const order = (!sort.value) ? sort : sort.value;

        return getAllArtistContact({
            artist: this.props.artistId,
            page: pageId,
            page_size: pageSize,
            search: search,
            ordering: order,
            tagsFilter: filters.tagsFilter?.value,
            cityFilter: filters.cityFilter?.value,
            stateFilter: filters.stateFilter?.value
        }, cancelToken)
    }

    deleteData = (id) => {
        return deleteArtistContact(id)
    }

    bulkUpdateData = (columns, dataArray, actionToken) => {
        let is_invalid_format = false
        let invalid_num_str = ''
        let bulkParams = []
        dataArray.forEach((data, index) => {
            if (data.length !== columns.length) {
                is_invalid_format = true
                invalid_num_str += (index + 1).toString() + ","
                return
            }
            //get id
            let length = columns.length
            const param = {}
            for (let i = 0; i < length; i++) {
                const key = columns[i].key
                param[key] = data[i]
            }
            bulkParams.push(param)
        })

        if (is_invalid_format) {
            message.error(("invalid format for row# " + invalid_num_str)).then(() => {
            })
        }
        return bulkPatchArtistContact(bulkParams, actionToken)
    }

    bulkAddData = (columns, dataArray, actionToken) => {
        let is_invalid_format = false
        let invalid_num_str = ''
        let bulkParams = []
        dataArray.forEach((data, index) => {
            if (data.length !== columns.length) {
                is_invalid_format = true
                invalid_num_str += (index + 1).toString() + ","
                return
            }
            //get id
            let length = columns.length
            const param = {'artist': this.props.artistId}
            for (let i = 0; i < length; i++) {
                const key = columns[i].key
                param[key] = data[i]
            }
            bulkParams.push(param)
        })

        if (is_invalid_format) {
            message.error(("invalid format for row# " + invalid_num_str)).then(() => {
            })
        }
        return bulkAddArtistContact(bulkParams, actionToken)
    }

    render() {
        return (
            <div>
                <GalleryTablePanel name={'contact'} requestData={this.requestData}
                    columns={this.columns} allColumns={this.allColumns} tableWidth={1200}
                    addNewUrl={URL_NEW_CONTACT}
                    importOptions={['excel', 'import_add_excel']}
                    getEditUrl={this.getEditUrl} deleteData={this.deleteData}
                    sortOptions={this.sortOptions} defaultSortOption={this.sortOptions[0]}
                    filterOptions={this.filterOptions}
                    bulkUpdateData={this.bulkUpdateData}
                    bulkAddData={this.bulkAddData}
                    galleryView={(props) => {
                        return <GalleryView galleryViewItem={(props) => {
                            return <GalleryContactCard {...props} />
                        }}
                            {...props} />
                    }}
                />
            </div>
        )
    }
}

export default withRouter(Contact)
